import React, { Fragment } from 'react';
import { Button } from 'react-admin';
import { makeStyles, alpha } from '@material-ui/core';
import DeleteButtonWithRedirect from '../../core/components/DeleteButtonWithRedirect';

const useStyles = makeStyles(theme => ({
  button: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    marginRight: '9px'
  },
  deleteButton: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    marginRight: '9px',
    '& svg': { display: 'none' }
  }
}));

const InvestorListBulkActions = props => {
  const {
    handleRelationshipOpen,
    hasReadFundInvestorPermission,
    hasDeleteFundInvestorPermission,
    selectedIds,
    showLoader,
    setShowLoader,
    ...rest
  } = props;
  const classes = useStyles();
  const handleRelationshipClick = async () => {
    const { selectedIds } = props;
    await handleRelationshipOpen(selectedIds[0]);
  };

  /* In case all IDs are selected, we should do a redirection to main grid after deletion.
    By doing this, we're avoiding the 'Element does not exist' message in case the investor
    becomes unavailable to the FA user (TFS-144613).
  */
  const allSelected = selectedIds.length === props.total;

  return (
    <Fragment>
      {hasReadFundInvestorPermission && selectedIds.length < 2 && (
        <Button
          className={classes.button}
          variant="outlined"
          color="primary"
          label="Edit Relationship"
          onClick={handleRelationshipClick}
        />
      )}
      {hasDeleteFundInvestorPermission && (
        <DeleteButtonWithRedirect
          className={classes.deleteButton}
          variant="outlined"
          color="primary"
          selectedIds={selectedIds}
          {...rest}
          undoable={false}
          confirmContent={
            allSelected
              ? 'Any wire instructions linked to the fund-investor relationship will be removed with this action. You are about to delete all your relations to this Investor, are you sure you want to proceed?'
              : 'Any wire instructions linked to the fund-investor relationship will be removed with this action. Are you sure you want to proceed ?'
          }
          redirectPath={allSelected ? '/investors' : undefined}
          redirect={allSelected ? 'list' : undefined}
        />
      )}
    </Fragment>
  );
};

export default InvestorListBulkActions;
